import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

const Svg = styled.svg`
	width: 100%;
	height: auto;
	fill: #ffffff;
`;
const SvgWrapper = styled.div`
	width: 44px;
	height: 44px;
`;

export const FacebookSvg = () => (
	<SvgWrapper>
		<Svg
			width="44px"
			height="44px"
			viewBox="0 0 44 44"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>631056F4-6CA7-4833-8173-D917CE902E32</title>
			<desc>Created with sketchtool.</desc>
			<g
				id="Asset-Artboard-Page"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g id="ic_facebook">
					<circle
						id="Oval"
						stroke="#FFFFFF"
						strokeWidth="2"
						cx="22"
						cy="22"
						r="21"
					/>
					<path
						d="M23.5437907,33 L18.8469735,33 L18.8469735,21.9986115 L16.5,21.9986115 L16.5,18.207902 L18.8469735,18.207902 L18.8469735,15.9320879 C18.8469735,12.8398132 20.1714961,11 23.9369859,11 L27.0710673,11 L27.0710673,14.792098 L25.1122664,14.792098 C23.6463945,14.792098 23.5495307,15.3218253 23.5495307,16.3104645 L23.5430731,18.207902 L27.0925926,18.207902 L26.6771546,21.9986115 L23.5430731,21.9986115 L23.5430731,33 L23.5437907,33 Z"
						id="Shape"
						fill="#FFFFFF"
					/>
				</g>
			</g>
		</Svg>
	</SvgWrapper>
);

export const TwitterSvg = () => (
	<SvgWrapper>
		<Svg
			width="44px"
			height="44px"
			viewBox="0 0 44 44"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>13918EB6-6D62-43B8-99A2-2965833D2774</title>
			<desc>Created with sketchtool.</desc>
			<g
				id="Asset-Artboard-Page"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g id="ic_twitter">
					<circle
						id="Oval"
						stroke="#FFFFFF"
						strokeWidth="2"
						cx="22"
						cy="22"
						r="21"
					/>
					<path
						d="M30.7483712,15.8827687 C31.6383166,15.3211624 32.3211833,14.4306525 32.6416623,13.3698407 C31.808417,13.8911465 30.8876563,14.2681507 29.905265,14.472253 C29.1213242,13.5882432 28.0008804,13.037037 26.7608734,13.037037 C24.3819334,13.037037 22.4541292,15.0715596 22.4541292,17.5805875 C22.4541292,17.9367915 22.489875,18.2838953 22.5638317,18.615399 C18.9843282,18.4255969 15.8103539,16.6185768 13.6840993,13.8677463 C13.3130833,14.5411537 13.1010741,15.3211624 13.1010741,16.1531717 C13.1010741,17.7287892 13.8615954,19.1198046 15.0177848,19.9362137 C14.3114985,19.9128134 13.647121,19.7061111 13.0653284,19.3681074 L13.0653284,19.424008 C13.0653284,21.6262325 14.5493925,23.4631529 16.5228033,23.8791575 C16.1604156,23.9857587 15.7807713,24.0390593 15.3863356,24.0390593 C15.1089981,24.0390593 14.8378236,24.011759 14.5765099,23.9584584 C15.1237894,25.7628784 16.7150907,27.0784931 18.6009861,27.1135934 C17.1255503,28.333007 15.2680049,29.0584151 13.2502201,29.0584151 C12.9026237,29.0584151 12.5587251,29.0389148 12.2222222,28.9960144 C14.129072,30.2843287 16.3933791,31.037037 18.826554,31.037037 C26.7522451,31.037037 31.0836415,24.1131601 31.0836415,18.1083934 C31.0836415,17.9107912 31.0811763,17.714489 31.072548,17.5207869 C31.9144216,16.8798797 32.6465927,16.0790708 33.2222222,15.1677607 C32.4493749,15.5291647 31.6185948,15.7735674 30.7483712,15.8827687 Z"
						id="Shape"
						fill="#FFFFFF"
					/>
				</g>
			</g>
		</Svg>
	</SvgWrapper>
);

export const WhatsappSvg = () => (
	<SvgWrapper>
		<Svg
			width="44px"
			height="44px"
			viewBox="0 0 44 44"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>ic_whatsapp</title>
			<desc>Created with Sketch.</desc>
			<g
				id="ic_whatsapp"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<circle
					id="Oval"
					stroke="#FFFFFF"
					strokeWidth="2"
					cx="22"
					cy="22"
					r="21"
				/>
				<path
					d="M11,32.8148148 L12.6036914,26.9561605 C11.6140988,25.2412469 11.0941111,23.2972346 11.0950617,21.3037901 C11.0979136,15.0715432 16.1694568,10 22.4007531,10 C25.4246667,10.0009506 28.2632099,11.1787654 30.3982963,13.3157531 C32.5324321,15.4527407 33.7073951,18.2931852 33.706445,21.3142469 C33.7035926,27.5474444 28.6320494,32.6189877 22.4007531,32.6189877 C20.5090247,32.618037 18.6448642,32.143679 16.993642,31.2424938 L11,32.8148148 Z M17.2712222,29.1958148 C18.8644568,30.141679 20.3854444,30.7082469 22.3969506,30.7091975 C27.5759136,30.7091975 31.7947531,26.4941605 31.7976056,21.3123457 C31.7995062,16.1200741 27.6006296,11.9107407 22.4045556,11.9088395 C17.2217901,11.9088395 13.0058025,16.1238765 13.0039001,21.3047407 C13.0029506,23.4198642 13.6227531,25.0035926 14.663679,26.6605185 L13.7140123,30.1283704 L17.2712222,29.1958148 Z M28.0959012,24.001642 C28.0255556,23.8837654 27.8373333,23.8134198 27.5540494,23.6717778 C27.271716,23.5301358 25.8828642,22.846642 25.6233457,22.7525309 C25.3647778,22.6584198 25.1765556,22.6108889 24.9873827,22.8941728 C24.7991605,23.1765062 24.2573086,23.8134198 24.0928519,24.001642 C23.9283951,24.1898642 23.7629877,24.2136296 23.4806543,24.0719877 C23.198321,23.9303457 22.2876296,23.6328025 21.208679,22.6698272 C20.369284,21.9207407 19.8017654,20.9957901 19.6373086,20.7125062 C19.4728519,20.4301728 19.6201975,20.2771235 19.7608889,20.1364321 C19.8882716,20.01 20.0432222,19.8065679 20.1848642,19.6411605 C20.3284074,19.4776543 20.3749877,19.3597778 20.4700494,19.1706049 C20.5641605,18.9823827 20.5175802,18.8169753 20.446284,18.6753333 C20.3749877,18.534642 19.810321,17.1438889 19.5755185,16.5782716 C19.3454691,16.0278642 19.1125679,16.1020123 18.9395556,16.0934568 L18.3977037,16.0839506 C18.2094815,16.0839506 17.9033827,16.1542963 17.6448148,16.4375802 C17.3862469,16.7208642 16.6561728,17.4034074 16.6561728,18.7941605 C16.6561728,20.1849136 17.6685802,21.5281358 17.8092716,21.716358 C17.9509136,21.9045802 19.8008148,24.7583333 22.6346049,25.9817778 C23.3085926,26.2726667 23.8352346,26.4466296 24.2449506,26.5768642 C24.9217901,26.7917037 25.5377901,26.761284 26.0245062,26.689037 C26.5673086,26.6082346 27.6956914,26.0055432 27.9314444,25.3458148 C28.1671975,24.6851358 28.1671975,24.1195185 28.0959012,24.001642 L28.0959012,24.001642 Z"
					id="Shape"
					fill="#FFFFFF"
					fillRule="nonzero"
				/>
			</g>
		</Svg>
	</SvgWrapper>
);
